// Feature 159: formattazione di token e soglie della barra consumi (blu, giallo oltre l'80%, rosso al 100%).

export type LivelloQuota = 'normale' | 'attenzione' | 'esaurita';

const formatoDecimale = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 1});
const formatoMilioni = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 2});

/** 950 → «950», 7300 → «7,3k», 100000 → «100k», 1080000 → «1,08M». */
export function formattaToken(token: number): string {
  const valore = Math.max(0, token ?? 0);
  if (valore >= 1_000_000) return `${formatoMilioni.format(valore / 1_000_000)}M`;
  if (valore >= 1_000) return `${formatoDecimale.format(valore / 1_000)}k`;
  return `${valore}`;
}

/** Percentuale della quota usata, tra 0 e 100; quota 0 (chat disattivata) = 100. */
export function percentualeQuota(usati: number, quota: number): number {
  if (quota <= 0) return 100;
  return Math.min(100, Math.round((Math.max(0, usati) / quota) * 100));
}

export function livelloQuota(usati: number, quota: number): LivelloQuota {
  if (quota <= 0 || usati >= quota) return 'esaurita';
  return usati > quota * 0.8 ? 'attenzione' : 'normale';
}

/** Ora locale dell'azzeramento (`HH:mm`), per il messaggio di quota esaurita. */
export function oraAzzeramento(azzeramento: Date): string {
  return new Intl.DateTimeFormat('it-IT', {hour: '2-digit', minute: '2-digit'}).format(azzeramento);
}
